export default "__VITE_ASSET__3faee631__"